import { UrlParams } from 'bluesquare-components';

export const SIDEBAR_WIDTH = 350;
export const MENU_HEIGHT_WITH_TABS = 112;
export const MENU_HEIGHT_WITHOUT_TABS = 65;

export const textPlaceholder = '--';

export const defaultTableParams: UrlParams = {
    pageSize: '20',
    order: '-created_at',
    page: '1',
};
